export default __webpack_public_path__ + "static/media/hinted-subset-Roboto-Regular.376ea5d9.woff";